<script>
// Подпись формата в списке качеств карточки плейлиста (PlaylistCard.vue): две колонки строки —
// «EXT + иконка без звука / аудио-дорожки» | качество. Функциональный: два корневых span встают
// прямо в сетку .playlist-quality__option (переключатель оборачивает их в .playlist-quality__label).
export default {
    name: 'FormatLabel',
    functional: true,
    props: {
        format: { type: Object, required: true },
    },
    render(h, { props }) {
        const f = props.format;
        const icons = [];
        // та же иконка без звука, что в таблице одиночного видео (.no-audio-icon)
        if (f.no_audio) {
            icons.push(h('span', { class: 'no-audio-icon', attrs: { title: 'No audio' } }, [h('i', { class: 'fas fa-volume-mute' })]));
        }
        if (f.audio) {
            icons.push(h('span', { class: 'audio-only-icon', attrs: { title: 'Audio only' } }, [h('i', { class: 'fas fa-music' })]));
        }
        return [
            h('span', { class: 'playlist-quality__ext' }, [String(f.ext || '').toUpperCase(), ...icons]),
            h('span', f.quality == null ? '' : String(f.quality)),
        ];
    },
};
</script>
